import { JuniorCampDeepLinkParameters } from '@lx/quote-tool/shared/services';

export type QTLiteJuniorCampDeepLinkParameters = JuniorCampDeepLinkParameters & { languageCode?: string };
